<template>
    <Transition name="app-loader">
        <div v-if="visible" class="app-loader" role="status" aria-live="polite" aria-label="Loading">
            <div class="app-loader__mark">
                <img src="~/assets/images/logo-dark.png" alt="" />
            </div>
            <div class="app-loader__track">
                <span class="app-loader__bar" />
            </div>
        </div>
    </Transition>
</template>

<script setup>
import { ref, watch } from 'vue';

const props = defineProps({
    active: {
        type: Boolean,
        default: true,
    },
});

// Keep the overlay mounted a beat after `active` goes false so the
// fade-out transition can finish instead of snapping away.
const visible = ref(props.active);

watch(
    () => props.active,
    (isActive) => {
        if (isActive) {
            visible.value = true;
        } else {
            setTimeout(() => {
                visible.value = false;
            }, 600);
        }
    }
);
</script>

<style lang="scss" scoped>
.app-loader {
    position: fixed;
    inset: 0;
    z-index: 9999;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 28px;
    background-color: #fefefe;
    &__mark {
        height: 80px;
        display: flex;
        align-items: center;
        animation: app-loader-breathe 1.8s ease-in-out infinite;
        img {
            height: 100%;
            width: auto;
        }
    }
    &__track {
        width: 140px;
        height: 2px;
        border-radius: 2px;
        background-color: $light-gray;
        overflow: hidden;
    }
    &__bar {
        display: block;
        width: 40%;
        height: 100%;
        border-radius: 2px;
        background-color: $brand-primary;
        animation: app-loader-slide 1.3s cubic-bezier(0.4, 0, 0.2, 1) infinite;
    }
}

@keyframes app-loader-breathe {
    0%,
    100% {
        opacity: 0.55;
        transform: scale(0.97);
    }
    50% {
        opacity: 1;
        transform: scale(1);
    }
}

@keyframes app-loader-slide {
    0% {
        transform: translateX(-120%);
    }
    100% {
        transform: translateX(340%);
    }
}

.app-loader-enter-active {
    transition: opacity 0.2s ease;
}
.app-loader-leave-active {
    transition: opacity 0.6s cubic-bezier(0.4, 0, 0.2, 1);
}
.app-loader-enter-from,
.app-loader-leave-to {
    opacity: 0;
}

@media (prefers-reduced-motion: reduce) {
    .app-loader__mark {
        animation: none;
    }
    .app-loader__bar {
        animation: none;
        width: 100%;
    }
}
</style>
